import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';
import type { MultipleFetchFunction, SingleFetchFunction } from '~/units/core/managers';

export const fetchBlogs: MultipleFetchFunction = async (limit = 10, offset = 0, order = '', { keyword } = {}) => {
  try {
    const query: {
      __limit: number;
      __offset: number;
      searchByKeyword?: string;
    } = {
      __limit: limit,
      __offset: offset,
    };
    if (keyword) {
      query.searchByKeyword = keyword as string;
    }

    return await useCaller(
      RequestProxy.N_AXON,
      RequestName.FETCH_BLOGS,
      'blogs',
      RequestMethod.GET,
      query,
      {},
      {
        cacheMode: 'only-speed-optimisation',
      },
    );
  } catch (e) {
    return [];
  }
};

export const fetchBlog: SingleFetchFunction = async (slug: string) => {
  try {
    return await useCaller(RequestProxy.N_AXON, RequestName.FETCH_BLOG, `blogs/${slug}`, RequestMethod.GET, {
      slug,
    });
  } catch (e) {
    return {};
  }
};
